export const nullParser = (rawValue) => {
  let value;
  if (typeof rawValue === 'string') {
    // NOTE: workaround for react-quill cannot properly clear content
    value = rawValue.replaceAll('<p><br></p>', '');
  } else {
    value = rawValue;
  }
  return value || null;
};

export const cleanString = (input) => {
  return input
    ?.trim() // remove leading/trailing spaces
    .replace(/[^\x20-\x7E]/g, ''); // remove all non-ASCII printable chars
};

// The fields that must pass validation before submitting. Identical for
// create and edit; event and training-camp categories add extra fields.
export const getValidationFields = (
  form,
  { eventCategoryCheck, trainingCampCategoryCheck, isInHotelTrainingSelected },
) => {
  const eventCategoryAdditionalParams = eventCategoryCheck
    ? {
        content: form.content,
        syllabus: form.syllabus,
        audience: form.audience,
        notes: form.notes,
        regionType: form.regionType,
      }
    : { code: form.code };

  const trainingCampCategoryAdditionalParams = trainingCampCategoryCheck
    ? {
        cityId: form.cityId,
        ...(isInHotelTrainingSelected ? { venueId: form.venueId } : {}),
      }
    : {};

  return {
    branchId: form.branchId,
    study_methodId: form.study_methodId,
    dayType: form.dayType,
    study_scheduleId: form.study_scheduleId,
    startDate: form.startDate,
    endDate: form.endDate,
    startTime: form.startTime,
    endTime: form.endTime,
    practiceStartTime: form.practiceStartTime,
    practiceEndTime: form.practiceEndTime,
    days: form.days,
    maxSeats: form.maxSeats,
    saleEndDate: form.saleEndDate,
    speakerIds: form.speakerIds,
    ...eventCategoryAdditionalParams,
    ...trainingCampCategoryAdditionalParams,
  };
};

export const getInvalidFieldNames = (fields) =>
  Object.keys(fields).filter((name) => !fields[name].valid);

// One payload builder for both create (POST) and edit (PUT) — the two
// endpoints accept identical keys.
export const buildSchedulePayload = (form, { eventCategoryCheck }) => {
  const optional = eventCategoryCheck
    ? {
        content: form.content.value,
        syllabus: JSON.stringify(form.syllabus.value),
        audience: JSON.stringify(form.audience.value),
        notes: form.notes.value,
        regionType: form.regionType.value,
      }
    : { code: cleanString(form.code.value) };

  return {
    branchId: form.branchId.value,
    study_methodId: form.study_methodId.value,
    study_scheduleId: form.study_scheduleId.value,
    startDate: form.startDate.value,
    endDate: form.endDate.value,
    startTime: form.startTime.value,
    endTime: form.endTime.value,
    practiceStartTime: form.practiceStartTime.value,
    practiceEndTime: form.practiceEndTime.value,
    days: cleanString(form.days.value),
    maxSeats: form.maxSeats.value,
    normalPrice: form.price.value,
    corporatePrice: form.corporatePrice.value,
    registrationFee: form.registrationFee.value,
    specialPrice: form.specialPrice.value,
    specialStartDate: form.specialStartDate.value,
    specialEndDate: form.specialEndDate.value,
    earlyPrice: form.earlyPrice.value,
    earlyStartDate: form.earlyStartDate.value,
    earlyEndDate: form.earlyEndDate.value,
    termPrice: form.termPrice.value,
    termStartDate: form.termStartDate.value,
    termEndDate: form.termEndDate.value,
    term2Price: form.term2Price.value,
    term2StartDate: form.term2StartDate.value,
    term2EndDate: form.term2EndDate.value,
    normalPromoPrice: form.normalPromoPrice.value,
    normalPromoStartDate: form.normalPromoStartDate.value,
    normalPromoEndDate: form.normalPromoEndDate.value,

    // NOTE: tenary to null so it does not results to an empty string / 0
    // for conditional fields
    cityId: nullParser(form.cityId.value),
    venueId: nullParser(form.venueId.value),
    dayType: nullParser(form.dayType.value),
    priceTitle: nullParser(cleanString(form.priceTitle.value)),
    priceTitleDesc: nullParser(cleanString(form.priceTitleDesc.value)),
    priceInfo: nullParser(form.priceInfo.value),
    priceQuota: nullParser(form.priceQuota.value),
    priceQuotaRemaining: nullParser(form.priceQuotaRemaining.value),
    specialQuota: nullParser(form.specialQuota.value),
    specialDesc: nullParser(form.specialDesc.value),
    specialInfo: nullParser(form.specialInfo.value),
    practiceDays: nullParser(cleanString(form.practiceDays.value)),

    corporateSaleStartDate: form.corporateSaleStartDate.value,
    corporateSaleEndDate: form.corporateSaleEndDate.value,
    saleEndDate: form.saleEndDate.value,
    speakerIds: form.speakerIds.value,
    programPrices: form.programPrices.value,
    programAdditionalPromos: form.programAdditionalPromos.value,
    hasWorkshopDetails: eventCategoryCheck,
    ...optional,
  };
};
